import requestIdleCallbackManager from 'Lib/requestIdleCallbackManager';
import { findMatchedRouteConfig } from 'Lib/utils/linkUtils';
import { isDataSavingMode, isOKConnection } from 'Lib/utils/networkCondition';

import { eventEmitter, PRELOAD_EVENT_LOAD } from './preload';

/**
 * Manage link preload
 */

export default class PreloadManager {
  paths: Set<string>;

  config: any[];

  constructor(config: any[]) {
    this.paths = new Set();
    this.config = config;
  }

  init = () => {
    eventEmitter.on(PRELOAD_EVENT_LOAD, this.preload);
  };

  destroy = () => {
    eventEmitter.removeListener(PRELOAD_EVENT_LOAD, this.preload);
    this.paths = new Set();
  };

  preload = (path: string, cb: () => void): void => {
    if (!isOKConnection() || isDataSavingMode()) {
      // don't preload if network is very bad
      return;
    }

    const matchedConfig = findMatchedRouteConfig(path, this.config);
    const matchedPath: string = matchedConfig?.match?.path;

    if (matchedConfig && matchedPath) {
      if (!this.paths.has(matchedPath)) {
        this.paths.add(matchedPath);

        const { routeConfig } = matchedConfig;
        const { regions } = routeConfig || {};

        if (regions) {
          Object.entries(regions).forEach(([, component]) => {
            if (component?.preload) {
              requestIdleCallbackManager.addTask(() => {
                component.preload?.().then(() => cb());
              });
            }
          });
        }
      }
    }
  };
}
